import { useState, useEffect } from 'react';

export const useReleases = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReleases = async () => {
      try {
        // Fetch fresh data from backend API (includes updated Deezer preview URLs)
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${backendUrl}/api/releases`);
        if (!response.ok) {
          throw new Error('Failed to fetch releases from API');
        }
        const json = await response.json();
        setData(json);
      } catch (err) {
        console.error('Error loading releases:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReleases();
  }, []);

  // Helper functions
  const getAlbumById = (id) => {
    return data?.albums?.find(album => album.id === id);
  };

  const getAlbumsByEra = (eraId) => {
    const era = data?.eras?.find(e => e.id === eraId);
    if (!era) return [];
    return data?.albums?.filter(album => era.albumIds.includes(album.id)) || [];
  };

  const getLatestAlbum = () => {
    if (!data?.albums?.length) return null;
    return [...data.albums].sort((a, b) => 
      new Date(b.releaseDate) - new Date(a.releaseDate)
    )[0];
  };

  const getAllTracks = () => {
    if (!data?.albums) return [];
    return data.albums.flatMap(album => 
      album.tracks.map(track => ({ ...track, album }))
    );
  };

  return {
    artist: data?.artist,
    albums: data?.albums || [],
    eras: data?.eras || [],
    streamingLinks: data?.streamingLinks,
    loading,
    error,
    getAlbumById,
    getAlbumsByEra,
    getLatestAlbum,
    getAllTracks,
  };
};
